import { render, staticRenderFns } from "./EditTeacherScheduleCard.vue?vue&type=template&id=17c8d006&scoped=true&"
import script from "./EditTeacherScheduleCard.vue?vue&type=script&lang=js&"
export * from "./EditTeacherScheduleCard.vue?vue&type=script&lang=js&"
import style0 from "./EditTeacherScheduleCard.vue?vue&type=style&index=0&id=17c8d006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8d006",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
